function getDayDifference(startDate, endDate) {
  const sDate = new Date(startDate);
  const eDate = new Date(endDate);

  // Calculate the difference in days between the two dates
  const differenceInTime = eDate.getTime() - sDate.getTime();
  const differenceInDays = Math.ceil(differenceInTime / (1000 * 3600 * 24));

  return differenceInDays;
}

export default getDayDifference;
